module.exports = __webpack_public_path__ + "static/media/pizzaNapolitana.c368768e.jpg";